export default __webpack_public_path__ + "media/images/logo_alt-14aa1fbd3322b51ee35f3c290f226114.svg";